
export const HeroDescription = () => {
  return (
    <p className="text-lg md:text-xl text-brutal-charcoal max-w-2xl mx-auto font-mono relative">
      <span className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-center gap-2 md:gap-4">
        <span>Automate Client Interactions</span>
        <span className="hidden md:inline-block">|</span>
        <span>Reduce No-Shows</span>
        <span className="hidden md:inline-block">|</span>
        <span>Boost Retail Sales</span>
      </span>
      <svg className="absolute -right-8 top-0 text-brutal-dark opacity-20 hidden md:block" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="16" stroke="currentColor" strokeWidth="4"/>
      </svg>
    </p>
  );
};
